import { useHotKeys } from 'Hooks'
import { useSpreadSheetData } from '../SpreadSheetDataProvider'
import WeaverService from 'Services/WeaverService'
import { setEdits, setSelection, setSelectionType } from '../SpreadSheetDataProvider/actions'
import { emptyCell, selectionTypes } from '../helpers'

export default RowSelectShortcuts = ->

  [{ columns, edits, selection }, dispatch] = useSpreadSheetData()

  useHotKeys([{
    sequence: ['right', 'tab']
    fn: ->
      dispatch(setSelectionType(selectionTypes.CELL))
      dispatch(setSelection([0, selection]))
    temporary: true
    watchers: [selection]
  }])

  useHotKeys([{
    sequence: 'up'
    fn: ->
      dispatch(setSelection(selection - 1))
    temporary: true
    expr: selection > 0
    watchers: [selection]
  }])

  useHotKeys([{
    sequence: ['down', 'enter']
    fn: ->
      dispatch(setSelection(selection + 1))
    temporary: true
    watchers: [selection]
  }])

  useHotKeys([{
    sequence: 'shift+up'
    fn: ->
      dispatch(setSelection([selection, selection - 1]))
      dispatch(setSelectionType(selectionTypes.MULTI_ROW))
    temporary: true
    expr: selection > 0
    watchers: [selection]
  }])

  useHotKeys([{
    sequence: 'shift+down'
    fn: ->
      dispatch(setSelection([selection, selection + 1]))
      dispatch(setSelectionType(selectionTypes.MULTI_ROW))
    temporary: true
    watchers: [selection]
  }])

  useHotKeys([{
    sequence: 'backspace'
    fn: ->
      newEdits =  {
        edits...,
        [selection]: ([0..(columns.length - 1)].reduce(((acc, j) ->
          {
            edits[j]...,
            acc...,
            [j]: emptyCell(columns[j])
          }
        ), {}))
      }
      dispatch(setEdits({
        prevEdits: edits
        nextEdits: newEdits
      }))
    temporary: true
    expr: WeaverService.userCanEdit()
    watchers: [selection, edits]
  }])

  <div />





